<template>
    <FilterBody
        v-model:search-model-value="finOpsManagerFilterProperties.searchTerm"
        :label="t('projectclient.projectlist.table.finOpsManager.header')"
        :display-search="true"
        :search-placeholder="t('projectclient.projectlist.topbar.filters.finopsmanager.search.placeholder')"
        :items="finOpsManagerFilterProperties.displayedResults"
        :selected-items="screenSizeSearchParams.finOpsManagers"
        :pending="finOpsManagerFilterProperties.pending"
        :display-show-more="finOpsManagerFilterProperties.hasMoreToShow && !finOpsManagerFilterProperties.isSearchActive"
        @reset="projectListFiltersStore.handleResetCategory('finOpsManagers')"
        @check:item="handleCheckBoxChange"
        @show-more="handleShowMore"
    >
        <template #item="{item}">
            {{
                `${item.label === 'deleted.account.firstName' ? t('deleted.account.firstName') : item.label} ${
                    item.count > 0 ? `(${item.count})` : ''
                }`
            }}
        </template>
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {TypedAggregationResource} from '@common/composables';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListStore, useProjectsListFiltersStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import FilterBody from '../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {temporarySearchParams, finOpsManagerFilterProperties} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed(() => {
        if (isSmallScreen.value) {
            return temporarySearchParams.value;
        } else {
            return searchParams.value;
        }
    });

    function handleCheckBoxChange(item: TypedAggregationResource<string>) {
        projectListFiltersStore.handleUpdateCategory('finOpsManagers', item.value);
    }

    function handleShowMore() {
        finOpsManagerFilterProperties.value.resultsSize += 6;
    }
</script>
